import React from "react";
import styled, { css } from "styled-components";
import AppConfig from "util/AppConfig";
import { Button, Col, Label, Row } from "components/bootstrap";
const RepositoryLabel = styled(Label)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.xs};
  `
);
const RepositoryDescription = styled.p(
  ({ theme, $isSelected }) => css`
    margin-bottom: 0;
    margin-top: ${theme.spacings.xs};
    font-size: ${theme.fonts.size.small};
    color: ${$isSelected ? theme.colors.variant.lightest.gray : theme.colors.variant.darker.gray};
  `
);
const RepositoryOption = ({ repository, onDelete, isSelected }) => {
  const isCloud = AppConfig.isCloud();
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 8 }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, repository.label, /* @__PURE__ */ React.createElement(RepositoryLabel, null, repository.type), /* @__PURE__ */ React.createElement(RepositoryLabel, { bsStyle: repository.ready ? "success" : "danger" }, repository.ready ? "Ready" : "Not Ready"))), repository.description && /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(RepositoryDescription, { $isSelected: isSelected }, repository.description)))), /* @__PURE__ */ React.createElement(Col, { md: 4, className: "text-right" }, !isCloud && /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", type: "button", onClick: (event) => onDelete(event, repository.value), bsStyle: "danger" }, "Delete")));
};
export default RepositoryOption;
